import CustomStore from 'devextreme/data/custom_store';
import { ref } from 'vue';
import useClientDistributionRepository from '@/modules/masterData/clientDistributions/repositories/clientDistribution.repository.js';
import store from '@/store/index';

export default function useDatagrid(clientId, periodId) {
  const mainClientDistribution = useClientDistributionRepository(clientId, periodId);
  const datasource = ref();

  const getDatasource = () => {
    datasource.value = new CustomStore({
      key: 'id',
      load: (loadOptions) => mainClientDistribution.load(loadOptions)
        .then((response) => ({
          data: response.data.data,
          totalCount: response.data.totalCount,
          summary: response.data.summary,
          groupCount: response.data.groupCount,
        })),
      update: (key, values) => new Promise((resolve, reject) => {
        mainClientDistribution.update(key, values)
          .then((response) => {
            if (response.data.success) {
              store.dispatch('addSuccessNotification', 'Dine ændringer er gemt');
              resolve(response);
            } else {
              if (response.data.messages.length > 0) {
                store.dispatch('addNotifications', { messageList: response.data.messages });
              }
              reject();
            }
          });
      }),
    });
  };

  const initFormFields = (e) => {
    const rowIndex = e.component.getRowIndexByKey(e.key);
    if (rowIndex >= 0) {
      e.component.focus(e.component.getCellElement(rowIndex, 'value'));
    }
  };

  return {
    datasource,
    getDatasource,
    initFormFields,
  };
}
